import {AudioDirector} from '../../components/audio-director.js';
import {MusicDirector} from '../../components/music-director.js';

export enum ToggleType {
    Sound,
    Music,
}

export function isSoundTurnedOn(type: ToggleType): boolean {
    switch (type) {
        case ToggleType.Sound:
            return AudioDirector.instance.soundEnabled;
        case ToggleType.Music:
            return MusicDirector.instance.musicEnabled;
    }
}

export function toggleSound(type: ToggleType) {
    switch (type) {
        case ToggleType.Sound:
            return (AudioDirector.instance.soundEnabled =
                !AudioDirector.instance.soundEnabled);
        case ToggleType.Music:
            return (MusicDirector.instance.musicEnabled =
                !MusicDirector.instance.musicEnabled);
    }
}
